import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { routerAppName } from '../../helpers/utils';
import { ProgressStep } from '../../enums/progressStep';
import './progress.scss';

const ProgressComponent = (props: any) => {
    const stepinfo = props?.sessionStep;
    const [stepMessage, setStepMessage] = useState('LOADING_STEP2');
    const { t } = useTranslation('browser');

    useEffect(() => {
        setProgressStep(stepinfo);
    }, );

    const setProgressStep = (step: ProgressStep) : void => {
        if(!step) {
            return;
        }
        switch (step) {
            case ProgressStep.GetApplication:
                setStepMessage('LOADING_STEP1');
                break;
            case ProgressStep.GetIcaFile:
                setStepMessage('LOADING_STEP2');
                break;
            case ProgressStep.SessionStart:
            case ProgressStep.ClientConnecting:
                setStepMessage('LOADING_STEP3');
                break;
            case ProgressStep.ClientConnected:
            case ProgressStep.ClientSessionReady:
            case ProgressStep.ClientSessionResized:
            case ProgressStep.RemoveOverlay:
                setStepMessage('LOADING_STEP4');
                break;
        }
        console.log(`** ${Math.round(window.performance.now())}: ${ProgressStep[step]}`); //NOSONAR
    }
    
    return (
        <div className="progress-component-container">
           <img src="/media/ctx-spinner.gif" alt="" className='loading-icon' />
            <div className="launch-header" data-testid="launch-header-msg">{ t(stepMessage, {appName: routerAppName}) }</div>
            <div className="launch-description">{ t('LOADING_MESSAGE') }</div>
        </div>
    )
   
}

export default ProgressComponent;